import { createReducer } from '../../../../../utils/fsa';
import { formSent, formError, setFormData } from '../action_creators/object_error_form_actions';
import { popupClosed } from '../../../../popup/action_creators/popup';

export interface IObjectErrorFormState {
  sent: boolean;
  error: Error;
  businessShoppingCenterId: number;
}

export default createReducer<IObjectErrorFormState>()

  .on(formSent, (state, action) => {
    return Object.assign({}, state, {
      sent: true,
      error: null,
    });
  })

  .on(formError, (state, action) => {
    return Object.assign({}, state, {
      sent: false,
      error: action.payload.error,
    });
  })

  .on(popupClosed, (state, action) => {
    return Object.assign({}, state, {
      sent: false,
      error: null,
    });
  })

  .on(setFormData, (state, action) => {
    return Object.assign({}, state, {
      businessShoppingCenterId: action.payload.businessShoppingCenterId,
    });
  })

  .build({
    sent: false,
    error: null,
    businessShoppingCenterId: null,
  });



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_center_detail/components/object_error_form/reducers/object_error_form_reducer.ts